import {
  RANGE_SENSITIVITY_SPREADSHEET_EQUITY_VALUE,
  RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW,
} from 'pages/ValuationsAllocation/common/constants/rangeSensitivity/sheetAliases';
import { getArrayValue, getNumberValue, getObjectValue } from 'utilities';
import { CreateColumns, RangeSensitivityColumn } from './types';

const createColumns: CreateColumns = params => {
  const { allocation, weightedShareValues } = params;

  // Column 1: Lower Bound (expression-driven)
  const lowerBoundColumn: RangeSensitivityColumn = {};

  // Column 2: Mid Point (Pulled from API data)
  const concludedValueColumn: RangeSensitivityColumn = {
    [RANGE_SENSITIVITY_SPREADSHEET_EQUITY_VALUE]: {
      value: getNumberValue(allocation?.current_equity_value),
    },
  };

  // Fund rows keyed by `${RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW}_${fund.id}`
  getArrayValue(weightedShareValues)?.forEach(wsv => {
    const fund = getObjectValue(wsv.fund);
    if (fund?.id) {
      const fundTotal = getArrayValue(wsv.share_values)?.reduce(
        (acc, sv) => acc + getNumberValue(sv.unrealized_value),
        0
      );
      concludedValueColumn[`${RANGE_SENSITIVITY_SPREADSHEET_FUND_ROW}_${fund.id}`] = { value: fundTotal };
    }
  });

  // Share value rows use expressions to equity allocation; no column seed values needed.

  // Column 3: Upper Bound (Calculated via expression)
  const upperBoundColumn: RangeSensitivityColumn = {};

  return [
    lowerBoundColumn,
    concludedValueColumn,
    upperBoundColumn,
  ];
};

export default createColumns;
